import React from 'react'
import Layout from '../components/Layout'
import * as styles from '../styles/our-story.module.scss'
import { graphql } from 'gatsby'
import { getImage, StaticImage } from 'gatsby-plugin-image'
import Header from '../components/Header'
import VerveH1 from '../components/VerveH1'

export default function OurStory({ data }) {

  const banner = getImage(data.banner)
  
  return (
    <Layout pageTitle="Our Story">
      <Header imageData={banner} bgClass={styles.header_bg}>
        <VerveH1 h1="Our Story"/>
      </Header>
      <section className={styles.our_story} id="main">
        <div className="container">
          <div>
            <h2>Humble Beginnings.</h2>
            <p>In <b>2015</b>, we started brewing kombucha and dreaming about a project that would see Verve bottles and draft lines in grocery stores, restaurants and breweries across Iowa. We brewed in mason jars. The kombucha was … not good; But we kept working at it.</p>
            <p>In <b>2017</b>, we submitted a proposal to build our brewery in a city-owned building in downtown Waterloo that had been vacant for a few years. Our proposal was accepted and we started working to build out our brewery and restaurant in the summer of <b>2018</b>.</p>
            <p>We moved up to five-gallon glass containers, started knocking out walls, and filling out paperwork. About a year and a half after our proposal was accepted, we opened the doors of Verve Kombucha.</p>
            <StaticImage
              src="../images/verve-sketch-exterior.jpg" 
              alt="a hand-drawn sketch of the exterior of Verve Kombucha"
              placeholder="blurred" 
              width={1200}
            />
          </div>
          <div className={styles.our_story_2}>
            <h2>Room to Grow.</h2>
            <p>We divided the building roughly in half to accommodate an event space alongside our brewery. In the brewery, we use much bigger equipment than the mason jars we started with; and we're working to distribute throughout the state.</p>
            <StaticImage
              src="../images/verve-sketch-interior.jpg" 
              alt="a hand-drawn sketch of the exterior of Verve Kombucha"
              placeholder="blurred" 
              width={1200}
            />
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    banner: file(relativePath: {eq: "verve_interior_ceiling.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH,
          placeholder: BLURRED
        )
      }
    }
  }
`;